import React from 'react';
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MdCloudDone } from "react-icons/md";
import './ThankYou.css';  // Importing custom CSS for styles
import {api} from "../../config"
const ThankYouPage = () => {

  const location = useLocation();
  const { resultSummary } = location.state || {};

  

  if (!resultSummary) {
    return <div>No result data available.</div>;
  }

  // Evaluate overall pass/fail based on the categories
  const overallResult = resultSummary.summary.every(
    (category) => category.passed === true
  )
    ? "Passed"
    : "Failed";

  return (
    <div className="thank-you-page">
      <div className="thank-you-card">
        {/* Card Header */}
        <div className="icon-container">
          <motion.div
            className="icon-animation"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            <MdCloudDone className="icon" />
          </motion.div>
        </div>
        {/* Thank You Message */}
        <h2 className="thank-you-message">Thank You for Completing the Quiz!</h2>
        <p className="guidelines-message">
          Your responses have been recorded. Please review your results below.
        </p>
        {/* Quiz Result */}
        <div className="quiz-result-container">
          <h2 className="quiz-result-title">🎓 Quiz Result</h2>
          <ul className="category-results">
            {resultSummary.summary.map((res, index) => (
              <li key={index} className="category-result-item">
                <strong>{res.category}</strong>: {res.correctAnswers}/{res.totalQuestions} correct —
                <span className={res.passed ? "passed" : "failed"}>
                  {res.passed ? "✅ Passed" : "❌ Failed"}
                </span>
              </li>
            ))}
          </ul>
          <hr />
          {/* Overall Result */}
          <div className="overall-result">
            <p>
              <strong>Overall: </strong>
              <span className={overallResult === "Passed" ? "passed" : "failed"}>
                {overallResult}
              </span>
            </p>
          </div>

          {/* Category-wise Results */}

        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;


